<template>
  <v-container fluid>

    <v-col cols="12">
      <i-card-vertical headerTitle="Block TransPort List" ></i-card-vertical>
      
        <template >
          <!-- <v-layout column overflow-auto> -->
            <!-- Search Condition -->
            <v-row class="d-flex">
              <!-- <v-col cols="12"> -->
                <!-- <v-card  outlined > -->
                  <v-col cols="6" ms="6" md="4" class="mt-2 mb-0">
                    <v-select label="Ship List" v-model="selectShipNo" 
                    :items="shipNoList" item-text="shipNo"
                      item-value="shipNo" return-object outlined dense />
                  </v-col>
                  <v-col cols="6" ms="6" md="4" class="mt-2 mb-0">
                    <v-select label="Transport List" v-model="selectTransCd" :items="transCdList" item-text="transNm"
                      item-value="transCd" return-object outlined dense />
                  </v-col>
                  <v-col cols="6" ms="6" md="4" class="mt-2 mb-0">
                    <v-btn  block class="mx-sm-2" small color="green" @click="btnRetrieve">
                     Retrieve
                    </v-btn>
                  </v-col>
                <!-- </v-card> -->
              <!-- </v-col> -->
            </v-row>
            <!-- Content -->
            <v-row dense>
              <v-col cols="12" ms="8" md="4" v-for="(translist, i) in translist" :key="i">
                <v-card color="green lighten-1" elevation="0" outlined class="rounded-lg"
                  style="overflow: hidden; margin: 15px 0;">

                  <v-row class="mt-0 mb-0">
                    <v-col cols="12">
                      <v-card color="blue lighten-5" elevation="0" outlined class="rounded-lg"
                        style="overflow: hidden; margin: 15px 0;">
                        <v-row align="start">
                          <v-col class="shrink">
                            <v-img :src="translist.empPic" max-width="70" class="ml-0"></v-img>
                          </v-col>
                          <v-col>
                            <v-row class="shrink">
                              <v-list subheader three-line color="blue lighten-5">
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>{{ translist.reqEnm }}</v-list-item-title>
                                    <v-list-item-subtitle>
                                      <div class="text-caption">Ext:{{ translist.officeTel }} - {{ translist.deptNm }}</div>
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row class="mt-1 mb-0">
                          <v-col>
                            <v-text-field v-model=translist.shipNo label="Ship No" outlined readonly height="25px"
                              dense></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-1 mb-0">
                          <v-col>
                            <v-text-field v-model=translist.block label="Block" outlined readonly height="25px"
                              dense></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-1 mb-0">
                          <v-col>
                            <v-select label="Transport Equipt" v-model=translist.trappEquip :items="transListNew"
                              item-text="transNm" item-value="transCd" return-object outlined dense />
                          </v-col>
                        </v-row>
                        <v-row class="mt-1 mb-0">
                          <v-col cols="6">
                            <v-text-field v-model=translist.dte type="date" label="Moving Request Date" outlined height="25px"
                              dense></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-model=translist.trappHh type="time" label="Moving Request Hour" readonly outlined height="25px"
                              dense></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-1 mb-0">
                          <v-col cols="6">
                            <v-text-field v-model=translist.trappHfr  type="time" label="Moving Time From" outlined height="25px"
                              dense></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-model=translist.trappHto type="time" label="Moving Time To" outlined height="25px"
                              dense></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-1 mb-0">
                          <v-col>
                            <v-text-field v-model=translist.frLoc label="From Loc" outlined height="25px"
                              dense></v-text-field>
                          </v-col>
                          <v-col>
                            <v-text-field v-model=translist.reqtoLoc label="To Loc" outlined height="25px"
                              dense></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="mt-1 mb-0">
                          <v-col>
                            <v-select v-model="translist.reasonCd" label="Moving Reason" :items="reasonList" item-text="reasonNm"
                              item-value="reasonCd" return-object outlined dense />
                          </v-col>
                        </v-row>
                        <v-row class="mt-1 mb-0">
                          <v-col>
                            <v-text-field v-model=translist.rmk label="Remark" outlined height="25px"
                              dense></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-card-actions class="grey lighten-4 d-flex justify-space-between">

                    <v-btn class="ml-12" icon color="green" @click="btNew(translist.shipNo)">
                      <v-icon>mdi-file-document-edit-outline</v-icon>
                    </v-btn>
                    <v-btn class="mr-12" icon color="green"  @click="btConf(i)"> 
                      <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>

          <!-- </v-layout> -->

          <v-btn v-scroll="onScroll" v-show="fab" fab dark fixed bottom right color="green" @click="toTop">
            <v-icon>mdi-chevron-up</v-icon>
          </v-btn>

          <v-dialog  v-model="dialogNew" scrollable height="100%" width="80%">         
          <v-card>           
            <template >
              <DxScrollView height="100%" width="100%"> 
                <v-row class="green">
                <v-card-title >
                  New Request
                </v-card-title>      
                <v-spacer/>
                <v-card-actions class="pa-5">                                    
                <v-btn color="green" @click="btDlgSave()" >
                  <v-icon >
                    mdi-content-save
                  </v-icon>
                </v-btn>              
                <v-btn color="green" @click="btClose()" >
                  <v-icon >
                    mdi-close-circle-outline
                  </v-icon>
                </v-btn>
              </v-card-actions>               
              </v-row>    
                <v-row class="mt-3 mb-0">
                  <v-col>
                    <v-text-field v-model=dlgShipNo label="Ship No" outlined readonly height="25px"
                      dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-0 mb-0">
                  <v-col>
                    <v-text-field v-model=dlgBlock label="Block" outlined height="25px"
                      dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-0 mb-0">
                  <v-col>
                    <v-select label="Transport Equipt" v-model=dlgTransCd :items="transListNew"
                      item-text="transNm" item-value="transCd" return-object outlined single-line dense />
                  </v-col>
                </v-row>
                <v-row class="mt-0 mb-0">
                  <v-col cols="6">
                    <v-text-field v-model=dlgDte type="date" label="Moving Date" outlined height="25px"
                      dense></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model=dlgHh type="time" label="Request Moving Time" outlined height="25px"
                      dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-0 mb-0">
                  <v-col>
                    <v-text-field v-model=dlgFr label="From Loc" outlined height="25px"
                      dense></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field v-model=dlgTo label="To Loc" outlined height="25px"
                      dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-0 mb-0">
                  <v-col>
                    <v-select label="Reason" v-model=dlgReason :items="reasonList" item-text="reasonNm"
                      item-value="reasonCd" return-object outlined single-line dense />
                  </v-col>
                </v-row>
                <v-row class="mt-0 mb-0">
                  <v-col>
                    <v-text-field v-model=dlgRmk label="Remark" outlined height="25px"
                      dense></v-text-field>
                  </v-col>
                </v-row>                      
              </DxScrollView>  
            </template> 
               
          </v-card>    
        </v-dialog>

        </template>
      <!-- </i-card-vertical> -->
      <!-- Scroll To Top -->

    </v-col>

    <VueToastify :notifyAction="notifyAction"></VueToastify>
  </v-container>
</template>

<script>

import ICardVertical from '@/components/common/iCardVertical.vue'
import { getv20a3000, getv20a3000ShipNo, getv20a3000ShipNoNew, getv20a3000TransCd, 
         getv20a3000Reason, v20a3000confMoving, getNormalDay, insertMovingReq } from '@/api/view/pp/20/v20a3000.js'
import { getEmpPic } from '@/api/view/pp/20/v20a1000.js'
import notify from 'devextreme/ui/notify'
import baseview from '@/components/base/baseview.vue'
import { DxScrollView } from "devextreme-vue/scroll-view";
import VueToastify from '@/components/toastify/VueToastify.vue'
import { getSysDate} from '@/api/view/pp/common/common.js'

export default {
  name: 'v30a3000',
  mixins: [baseview],
  components: {
    ICardVertical, 
    DxScrollView, VueToastify
    
  },
  data: () => ({
    fab: false,
    translist: [],
    selectShipNo: '',
    shipNoList: [],
    shipNo: '%',
    
    trappEquipNm: '',

    selectTransCd: '',
    transCdList: [],
    transCd: '',
    transListNew: [],
    
    trappHfr: '',
    trappHto: '',

    selectReason: '',
    reasonList: [],
    reason: '',
    dialogNew: false,
    dlgShipNo:'', 
    dlgBlock: '',
    dlgTransCd:'',     
    dlgDte:'', 
    dlgHh:'', 
    dlgFr: '',
    dlgTo:'',
    dlgReason:'', 
    dlgRmk:'', 

    chktoday: '',
    chk: ''

  }),

  methods: {

    notifyAction(notifyInfo, action) {
      this.$EventBus.$emit(`${this.$route.meta.menu_id}_notifyAction`, { notifyInfo: notifyInfo, action: action })
    },


    btNew(e) {
      let param = {
        format: 0
      } 

      getSysDate(param).then(res => {
          this.dlgDte = res.list[0].aftDate
          this.chktoday = res.list[0].aftDate

        })
        this.dlgShipNo = e
        this.dialogNew = true;            
    },

    btDlgSave() {  
      
        if(this.dlgBlock == null || !this.dlgBlock)
        {
          this.vToastify(this.$t('Please input block.'), 'warn')
          return
        }

        if(this.dlgTransCd.transCd == null || !this.dlgTransCd.transCd)
        {
          this.vToastify(this.$t('Please select transport.'), 'warn')
          return
        }

        if(this.chktoday > this.dlgDte)
        {
          this.vToastify(this.$t('Please check moving request date.'), 'warn')
          return
        }

        if(this.dlgReason.reasonCd == null || !this.dlgReason.reasonCd)
        {
          this.vToastify(this.$t('Please select moving reason.'), 'warn')
          return
        }

        if(this.dlgHh == null || !this.dlgHh)
        {
          this.vToastify(this.$t('Please select request moving time.'), 'warn')
          return
        }

        let param = {
          dte:        this.dlgDte,
          trappinSbn:      this.$store.state.user.userId
        }  

        getNormalDay(param).then(res => {          
            this.chk = res.list[0].yn
          })
        
        if( this.chk =='N')
        {
          this.vToastify(this.$t('If input transfer block request for today, you must input before 15h30!'), 'warn')
          return      
        }
      
        let params = {
            shipNo:     this.dlgShipNo,
            block:      this.dlgBlock,
            trappinDt:  this.dlgDte,
            trappEquip: this.dlgTransCd.transCd, 
            frLoc:      this.dlgFr,
            reqtoLoc:   this.dlgTo,
            trappGu:    this.dlgReason.reasonCd,
            trappHh:    this.dlgHh.substr(0, 2),              
            trappMm:    this.dlgHh.substr(3, 2),
            trappinSbn: this.$store.state.user.userId,
            dte:        this.dlgDte,
            rmk:        this.dlgRmk 
           
          }
          
          console.log("btDlgSave", params)    

          this.openLoading('Insert Request')
                      
          insertMovingReq(params).then(res => {                

                if (res.body === 'OK') {
                    notify(this.$t('Save data is completed.'), 'success', 3000)
                } else {
                    this.vToastify(this.$t('An error has been occured while saving data. ' + res.body ), 'warn')
                }
            })
                .catch(error => {
                    this.vToastify(error, 'warn')
                    this.endLoading()
                })
                .finally(() => {               
                    this.dialogNew = false;          
                    this.btnRetrieve()
                    this.endLoading()
                })     
      },


    btClose() {        
        this.dialogNew = false
      },

    btConf(row) {
            
            // console.log(this.translist[row].trappHfr)

            if(this.translist[row].trappHfr == null) {
              this.vToastify(this.$t('Pls select actual moving time from.'), 'warn')
              return
            }

            if(this.translist[row].trappHto == null) {
              this.vToastify(this.$t('Pls select actual moving time to.'), 'warn')
              return
            }

            if(this.translist[row].trappEquip.transCd == null) {
              this.vToastify(this.$t('Pls select transport equipment.'), 'warn')
              return
            }


            let params = {
                      reqNo: this.translist[row].reqNo,
                      trappinDt: this.translist[row].dte,
                      trappEquip: this.translist[row].trappEquip.transCd, 
                      frLoc: this.translist[row].frLoc,
                      reqtoLoc: this.translist[row].reqtoLoc,
                      trappGu: this.translist[row].reasonCd.reasonCd,
                      trappHh: this.translist[row].trappHh.substr(0, 2),              
                      trappMm: this.translist[row].trappHh.substr(3, 2),
                      empNo: this.$store.state.user.userId,
                      dte: this.translist[row].dte, 
                      trappHfr: this.translist[row].trappHfr.substr(0, 2) + this.translist[row].trappHfr.substr(3, 2),
                      trappHto: this.translist[row].trappHto.substr(0, 2) + this.translist[row].trappHto.substr(3, 2)
                    }
                              
                this.vToastifyPrompt(        
                    this.$t('Are you sure to confirm this request?'),
                    'info',
                    current => {
                      this.openLoading()
                
                      v20a3000confMoving(params).then(res => {

                        const msg = res.body

                        if(msg === 'OK') {
                          notify(this.$t('Confirmation is completed.'), 'success', 3000)
                          this.btnRetrieve()
                        } else {
                          this.vToastify(this.$t(msg), 'warn')
                        }
                      }).catch(error => {
                        this.vToastify(error, 'warn')
                      }).finally(() => {
                        this.endLoading()
                      })

                    },
                    null,
                    false
                  )
        
      
    },

    btnRetrieve() {

      this.doSearchTransList()
    },

    async doSearchTransList() {

      if (this.selectShipNo.shipNo == null) {
        this.selectShipNo.shipNo ='%'
      }

      let params = {
        shipNo: this.selectShipNo.shipNo,
        trappEquip: this.selectTransCd.transCd,
        empNo: this.$store.state.user.userId
      }
      
      // this.openLoading()
      await getv20a3000(params).then(res => {

        let list = []
        let list2 = []
        let cnt = 1;

        res.list.forEach(e => {
          let param = {
            empNo: e.trappinSbn,
          }
          // console.log(param)

          getEmpPic(param).then(res => {
            this.empPic = res.body;

          }).finally(() => {

            list.push(
              {
                id: cnt++, reqNo: e.reqNo, dte: e.dte, shipNo: e.shipNo,
                block: e.block, trappHh: e.trappHh, trappEquip: { transCd: e.trappEquip, transNm : "" }, trappPos: e.trappPos,
                frLoc: e.frLoc, reqtoLoc: e.reqtoLoc, trappGu: e.trappGu, trappinDt: e.trappinDt,
                trappinSbn: e.trappinSbn, rmk: e.rmk, deptNm: e.deptNm, officeTel: e.officeTel,
                reqEnm: e.reqEnm, reqtime: e.reqtime, reasonCd: { reasonCd: e.reasonCd, reasonNm: "" }, empPic: this.empPic,
                trappHfr: e.trappHfr, trappHto: e.trappHto 

              }
            )
            
          })


        });
        this.translist = list        

      }).finally(() => {
        // this.endLoading()
      })

    },

    getEmpPicture(empno) {
      try {
        // this.openLoading('searching')
        let params = {
          deptCd: "",
          grpCd: "",
          appCd: "",
          empNo: empno,
        }
        getEmpPic(params).then(res => {
          this.empPic = res.body;
          // console.log('res', res.body);
          return res.body;

        })

      } finally {
        // this.endLoading()
      }
    },

    getShipNoList() {

      // console.log("getShipNoList");

      getv20a3000ShipNo().then(res => {

        // console.log(res.list);
        this.shipNoList = res.list
        this.shipNoList.unshift({
          shipNo: '%'
        })
        this.selectShipNo = this.shipNoList[0]
      })
    },


    getTransListNew() {

      getv20a3000TransCd().then(res => {

        this.transListNew = res.list        

      })
    },

    getTransList() {

      getv20a3000TransCd().then(res => {

        this.transCdList = res.list
        this.transCdList.unshift({
          transCd: '%',
          transNm: 'All'
        })
        this.selectTransCd = this.transCdList[0]
      })
    },

    getReasonList() {

      getv20a3000Reason().then(res => {

        this.reasonList = res.list
      })
    },

    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop() {
      this.$vuetify.goTo(0)
    },

  },

  mounted() {
    this.getShipNoList()
    this.getTransList()
    this.getReasonList()
    this.getTransListNew()
  },


}
</script>

<style scoped>
.col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
    width: 100%;
    padding: 3px;
}
.container {
    width: 100%;
    padding: 2px;
    margin-right: auto;
    margin-left: auto;
}
</style>